import React from 'react';
import { Globe, Lock } from 'lucide-react';
import { CHANNEL, CHANNEL_LABELS, getBookingChannel, getInvoiceChannel } from '../../utils/bookingSource';

/**
 * Compact Internal / External badge for vendor lists.
 * Pass `channel` directly, or a `booking` / `invoice` to resolve.
 */
const ChannelBadge = ({
  channel = null,
  booking = null,
  invoice = null,
  className = '',
  showIcon = true,
}) => {
  const resolved =
    channel ||
    (booking ? getBookingChannel(booking) : null) ||
    (invoice ? getInvoiceChannel(invoice) : null) ||
    CHANNEL.INTERNAL;

  const isExternal = resolved === CHANNEL.EXTERNAL;
  const Icon = isExternal ? Lock : Globe;
  const label = CHANNEL_LABELS[resolved] || CHANNEL_LABELS.internal;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide ${
        isExternal
          ? 'bg-gray-900 text-white'
          : 'bg-surface-muted text-ink border border-border'
      } ${className}`.trim()}
    >
      {showIcon ? <Icon className="w-3 h-3 shrink-0" aria-hidden /> : null}
      {label}
    </span>
  );
};

export default ChannelBadge;
